import Page from "@/components/layout/Page";

export default function SENDCO() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">SENDCO</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Hear from Special Educational Needs Coordinators about their experiences with Samboards.
            </p>
            
            <p className="text-lg leading-relaxed">
              SENCOs across the UK rely on Samboards to support students with additional needs. Our products have become essential tools in SEND provisions, helping children self-regulate, maintain focus, and feel calm in educational environments.
            </p>
            
            <p className="text-lg leading-relaxed">
              School coordinators report that Samboards are invaluable for creating inclusive classrooms where every child can access learning. They're used in sensory rooms, during lessons, and as part of individual support plans for students with autism, ADHD, and sensory processing needs.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
